// Sidebar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Sidebar.css';
import logo from '../../kungfu_logo.png';

/* === 内联 SVG 图标 === */
const OverviewIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    {/* 饼图：和当前文字同色 */}
    <path fill="currentColor" d="M11 2a1 1 0 0 1 1 1v8h8a1 1 0 0 1 1 1 10 10 0 1 1-10-10zM13 4.06A8 8 0 1 0 19.94 11H13V4.06z"/>
  </svg>
);

const StoresIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    {/* 小店铺/卡片 */}
    <path fill="currentColor" d="M4 5h16a1 1 0 0 1 1 1v3.5a3.5 3.5 0 0 1-6.5 1.93A3.49 3.49 0 0 1 12 13a3.49 3.49 0 0 1-2.5-1.07A3.5 3.5 0 0 1 3 9.5V6a1 1 0 0 1 1-1zm0 11a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3z"/>
  </svg>
);

const Sidebar = () => {
  const { t } = useTranslation();
  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <img src={logo} alt="KFD" />
        {/* <span>KFD</span> */}
      </div>

      <div className="sidebar-section">
        <h4>{t('Pages')}</h4>
        <ul>
          <li>
            <NavLink to="/overview" className={({ isActive }) => (isActive ? 'active' : '')}>
              <span className="nav-icon"><OverviewIcon /></span>
              <span className="nav-text">{t('Overview')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/stores" className={({ isActive }) => (isActive ? 'active' : '')}>
              <span className="nav-icon"><StoresIcon /></span>
              <span className="nav-text">{t('Stores')}</span>
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="sidebar-section">
        <h4>{t('Dashboards')}</h4>
        <ul>
          {/* <li><NavLink to="/net-sales" className={({ isActive }) => (isActive ? 'active' : '')}>{t('Net Sales')}</NavLink></li>
          <li><NavLink to="/cash-flow" className={({ isActive }) => (isActive ? 'active' : '')}>{t('Cash Flow')}</NavLink></li>
          <li><NavLink to="/media-spend" className={({ isActive }) => (isActive ? 'active' : '')}>{t('Media Spend')}</NavLink></li> */}
              <li>
              <NavLink to="/net-sales" className={({ isActive }) => (isActive ? 'active' : '')}>
                <span className="nav-text">{t('Net Sales')}</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/cash-flow" className={({ isActive }) => (isActive ? 'active' : '')}>
                <span className="nav-text">{t('Cash Flow')}</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/media-spend" className={({ isActive }) => (isActive ? 'active' : '')}>
                <span className="nav-text">{t('Media Spend')}</span>
              </NavLink>
        </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
